interface BoardCommentStatus {
  todayReply: number;
  total: number;
}

export default function BoardCommentStatus({
  todayReply,
  total,
}: BoardCommentStatus) {
  return (
    <div className="flex gap-5 text-xs pb-3  border-b border-zinc-50/5 mt-5 ">
      <div className=" from-zinc-800   ">
        <span className="text-zinc-400">오늘 작성된 댓글</span>
        <span className="ml-2 border-b border-zinc-600  text-sm">
          {todayReply}
        </span>
      </div>
      <div className=" ">
        <span className="text-zinc-400">전체 댓글</span>{" "}
        <span className="ml-2 border-b border-zinc-600 text-sm">{total}</span>
      </div>
    </div>
  );
}
